export const STEPS = [
  {
    label: 'Salesforce ID',
    title: 'Step 1: Add offer ID from Salesforce',
    helperText: 'Enter the Salesforce offer ID to start the set up flow.',
  },
  {
    label: 'Property',
    title: 'Step 2: Check or create property',
    helperText: 'Use an existing property, or create a new property using defaults.',
  },
  {
    label: 'Rooms',
    title: 'Step 3: Create rooms on property',
    helperText: 'Room details will be added here.',
  },
  {
    label: 'Rate plan',
    title: 'Step 4: Create Flash Rate Plan',
    helperText: 'Rate plan details will be added here.',
  },
  {
    label: 'Room rates',
    title: 'Step 5: Apply Rate Plan to selected rooms',
    helperText: 'Choose which rooms should use the new Flash Rate Plan.',
  },
  {
    label: 'Capacity',
    title: 'Step 6: Review room capacity',
    helperText: 'Review and apply capacity to the new Flash room rates.',
  },
  {
    label: 'Taxes & fees',
    title: 'Step 7: Taxes and Fees',
    helperText: 'Taxes and fees will be selected from the country rules.',
  },
  {
    label: 'Content',
    title: 'Step 8: Go to Content page',
    helperText: 'Content information will be reviewed on the Content page.',
  },
];

export const CREATE_NEW_PROPERTY = 'create-new-property';
export const DEFAULT_NEW_PROPERTY_LOGO_ID = 'ame2pu7ycca2scvuqhqq';
export const PROPERTY_FORM_ID = 'flash-offer-property-form';
export const TAXES_FEES_FORM_ID = 'flash-offer-taxes-fees-form';
